import React from 'react';

interface StepProgressProps {
  totalSteps: number;
  currentStep: number;
}

export const StepProgress: React.FC<StepProgressProps> = ({
  totalSteps,
  currentStep,
}) => {
  return (
    <div className="flex h-1 w-full items-start justify-start gap-1.5">
      {Array.from({ length: totalSteps }).map((_, index) => {
        const stepNumber = index + 1;
        const isActive = index < currentStep;
        return (
          <div
            key={`step-${stepNumber}`}
            className="relative h-1 grow overflow-hidden rounded-sm bg-[#e4e7ec]"
          >
            <div
              className={`absolute top-0 left-0 h-full rounded-sm bg-[#141c25] transition-all duration-500 ease-in-out ${
                isActive ? 'w-full' : 'w-0'
              }`}
            />
          </div>
        );
      })}
    </div>
  );
};
